import React, { Component } from 'react';
import RowHistorialTarjetas from './RowHistorialTarjetas';

class HistorialTarjetas extends Component {
    constructor(props) {
        super(props);
        this.abrirPopUp = this.abrirPopUp.bind(this);
    }

    abrirPopUp(modalId, abrirCerrar) {
        this.props.abrirPopUp(1, abrirCerrar) 
    }

    render() { 
          
        let { HistorialTarjetas }= this.props.HistorialTarjetas;
        let cuerpoTabla;
 
        cuerpoTabla = HistorialTarjetas.map((tarjeta,indice)=><RowHistorialTarjetas HistorialTarjetas={tarjeta} indice={indice}/>)

        return (
            <div className='modalContainer'>
                <div className='modalHistorialModificacionOutXL'>
                    <div>
                        <div className='modalDemandaHeader bottom-separator-HistorialTarjetas'>
                            <div className='modalProcesosDocumentadosHeaderText'>
                                Registro histórico de tarjetas
                        </div>
                            <label onClick={() => this.props.abrirPopUp(1, false)} className='ti-close clickable modalProcesosClose closeProcesosDemanda'></label>
                        </div>
                        <table className="tablaHistorialTarjetas">
                            <thead>
                                <tr>
                                    <th className="rowBordersVistaClienteNoSides">Denominación</th>
                                    <th className="rowBordersVistaClienteNoSides">Número</th>
                                    <th className="rowBordersVistaClienteNoSides">Tipo</th>
                                    <th className="rowBordersVistaClienteNoSides">Cuarta Línea</th>
                                    <th className="rowBordersVistaClienteNoSides">Fecha de hab.</th>
                                    <th className="rowBordersVistaClienteNoSides">Vigencia</th>
                                </tr>
                            </thead>
                            <tbody>
                                {cuerpoTabla}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    }
}
export default HistorialTarjetas;